import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { Comment, Avatar, Tooltip, Rate, Alert, Empty } from 'antd'

import './SidebarReviews.scss'

import { ReviewsButtonModal } from './Reviews'

const SidebarReviews = ({ reviewId, userId, type }) => {
  const reviews = useSelector(state => state.reviews.reviews)

  const [userReviews, setReviews] = useState(reviews)

  useEffect(() => {
    setReviews(reviews)
  }, [reviews])

  const hasUserReviewed = !!reviews.find(item => item.user_id === userId)
  const noReviews = reviews.length === 0

  return (
    <div className="reviews_container">
      <div className="reviews_list">
        {!noReviews &&
          userReviews.map(review => <RatingItem review={review} />)}
        {noReviews && <Empty description={'No Reviews Found.'} />}
      </div>

      {!hasUserReviewed && (
        <ReviewsButtonModal id={reviewId} userId={userId} type={type} />
      )}
      {hasUserReviewed && (
        <Alert message={`You have already rated this ${type}.`} type="info" />
      )}
    </div>
  )
}

const RatingItem = ({ review }) => {
  const {
    avatar,
    username,
    rating,
    review: text,
    created_at  } = review

  const actions = [
    <span key="comment-basic-like">
      <Tooltip title="Rating">
        <Rate disabled value={rating} />
      </Tooltip>
      <span style={{ paddingLeft: 8, cursor: 'auto' }}>
        {rating.toFixed(1)} / 5
      </span>
    </span>
  ]

  return (
    <>
      <Comment
        actions={actions}
        author={<b>{username}</b>}
        avatar={<Avatar src={avatar} alt={username} />}
        content={<p>{text}</p>}
        datetime={
          <Tooltip title={moment(created_at).format('YYYY-MM-DD hh:mm A')}>
            <span className="reviews_list_time">
              {moment(created_at).fromNow()}
            </span>
          </Tooltip>
        }
      />
      <hr />
    </>
  )
}

export default SidebarReviews
